import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
import './theme/answerrocket-bui.css';
import './theme/design-system.css';

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
